export default "__VITE_ASSET__DGnqZx$h__"